/* eslint-disable no-undef */
import axios from 'axios'
import * as types from '../constantes/user'

type ICourses = {
  courseName: string
}

type CreateRegisterActionProps = (name: string, cpf: string, email: string, phone: string, courses: ICourses[]) => void
type DispatchCreateRegisterAction = (args: {
  type: string
  payload:
    | string
    | {
        name: string
        cpf: string
        email: string
        cellPhone: string
        courses: ICourses[]
      }
}) => void

export const CreateRegisterAction: CreateRegisterActionProps =
  (name, cpf, email, cellPhone, courses) => async (dispatch: DispatchCreateRegisterAction) => {
    dispatch({
      type: types.CREATE_REGISTER_REQUEST,
      payload: {
        name,
        cpf,
        email,
        cellPhone,
        courses
      }
    })

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/register/add`, {
        name,
        cpf,
        email,
        cellPhone,
        courses
      })
      dispatch({
        type: types.CREATE_REGISTER_SUCCESS,
        payload: data.message && data.message
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.CREATE_REGISTER_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }

type ValidateRegisterActionProps = (code: string) => void
type DispatchValidateRegisterAction = (args: {
  type: string
  payload:
    | string
    | {
        code: string
      }
}) => void

export const ValidateRegisterAction: ValidateRegisterActionProps =
  code => async (dispatch: DispatchValidateRegisterAction) => {
    dispatch({
      type: types.VALIDATE_REGISTER_REQUEST,
      payload: {
        code
      }
    })

    try {
      const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/register/confirm`, {
        code
      })
      dispatch({
        type: types.VALIDATE_REGISTER_SUCCESS,
        payload: data.message && data.message
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.VALIDATE_REGISTER_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }

type ListRegisterActionProps = (key: string) => void
type DispatchListRegisterAction = (args: {
  type: string
  payload:
    | string
    | {
        key: string
      }
}) => void

export const ListRegisterAction: ListRegisterActionProps = key => async (dispatch: DispatchListRegisterAction) => {
  dispatch({
    type: types.LIST_REGISTER_REQUEST,
    payload: {
      key
    }
  })

  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/register/list`, {
      key
    })
    dispatch({
      type: types.LIST_REGISTER_SUCCESS,
      payload: data
    })
  } catch (error) {
    if (axios.isAxiosError(error)) {
      dispatch({
        type: types.LIST_REGISTER_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message
      })
    }
  }
}

type GenerateExcelActionProps = (key: string) => void
type DispatchGenerateExcelAction = (args: {
  type: string
  payload:
    | string
    | {
        key: string
      }
}) => void

export const GenerateExcelAction: GenerateExcelActionProps = key => async (dispatch: DispatchGenerateExcelAction) => {
  dispatch({
    type: types.GENERATE_EXCEL_REQUEST,
    payload: {
      key
    }
  })

  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/register/generate`, {
      key
    })
    dispatch({
      type: types.GENERATE_EXCEL_SUCCESS,
      payload: data
    })
  } catch (error) {
    if (axios.isAxiosError(error)) {
      dispatch({
        type: types.GENERATE_EXCEL_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message
      })
    }
  }
}

type GetRegisterByCpfActionProps = (cpf: string) => void
type DispatchGetRegisterByCpfAction = (args: {
  type: string
  payload:
    | string
    | {
        cpf: string
      }
}) => void

export const GetRegisterByCpfAction: GetRegisterByCpfActionProps =
  cpf => async (dispatch: DispatchGetRegisterByCpfAction) => {
    dispatch({
      type: types.GET_REGISTER_BY_CPF_REQUEST,
      payload: {
        cpf
      }
    })

    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/register/${cpf}`)
      dispatch({
        type: types.GET_REGISTER_BY_CPF_SUCCESS,
        payload: data
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.GET_REGISTER_BY_CPF_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }

type VerifyRegisterActionProps = (cpf: string) => void
type DispatchVerifyRegisterAction = (args: {
  type: string
  payload:
    | string
    | {
        cpf: string
      }
}) => void

export const VerifyRegisterAction: VerifyRegisterActionProps =
  cpf => async (dispatch: DispatchVerifyRegisterAction) => {
    dispatch({
      type: types.VERIFY_REGISTER_REQUEST,
      payload: {
        cpf
      }
    })

    try {
      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/register/verify`, {
        cpf
      })
      dispatch({
        type: types.VERIFY_REGISTER_SUCCESS,
        payload: data
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.VERIFY_REGISTER_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }

type ReSendSMSActionProps = (cellPhone: string) => void
type DispatchReSendSMSAction = (args: {
  type: string
  payload:
    | string
    | {
        cellPhone: string
      }
}) => void

export const ReSendSMSAction: ReSendSMSActionProps = cellPhone => async (dispatch: DispatchReSendSMSAction) => {
  dispatch({
    type: types.RESEND_SMS_REQUEST,
    payload: {
      cellPhone
    }
  })

  try {
    const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/register/resend`, {
      cellPhone
    })
    dispatch({
      type: types.RESEND_SMS_SUCCESS,
      payload: data.message && data.message
    })
  } catch (error) {
    if (axios.isAxiosError(error)) {
      dispatch({
        type: types.RESEND_SMS_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message
      })
    }
  }
}

type UpdatePhoneActionProps = (cellPhone: string, id: string) => void
type DispatchUpdatePhoneAction = (args: {
  type: string
  payload:
    | string
    | {
        cellPhone: string
        id: string
      }
}) => void

export const UpdatePhoneAction: UpdatePhoneActionProps =
  (cellPhone, id) => async (dispatch: DispatchUpdatePhoneAction) => {
    dispatch({
      type: types.UPDATE_PHONE_REQUEST,
      payload: {
        cellPhone,
        id
      }
    })

    try {
      const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/register/update/${id}`, {
        cellPhone
      })
      dispatch({
        type: types.UPDATE_PHONE_SUCCESS,
        payload: data.message && data.message
      })
    } catch (error) {
      if (axios.isAxiosError(error)) {
        dispatch({
          type: types.UPDATE_PHONE_ERROR,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message
        })
      }
    }
  }
